<template>
    <div class="historic column">
        <div class="title row">
            <div class="grid-3">QUANDO</div>
            <div class="grid-3">QUEM</div>
            <div class="grid-8">DESCRIÇÂO</div>
        </div>
        <div v-for="row of historic" :key="'h' + row.id" class="row line align-center">
            <div class="grid-3"><b>{{ row.criado_em | date }}</b></div>
            <div class="grid-3">{{ row.nome_criado_por }}</div>
            <div class="grid-8">{{ row.descricao }}</div>
        </div>
    </div>
</template>
  
  
<script>
import { mapActions } from "vuex";

export default {
    components: {},
    props: ["ID"],
    data() {
        return { historic: [] };
    },
    beforeMount() {
        this.getHistoric()
    },
    methods: {
        ...mapActions("admin", ["ADMIN_HISTORIC"]),
        getHistoric() {
            this.ADMIN_HISTORIC(this.ID).then(({ data }) => {
                if (data && data.length) this.historic = data
            });
        },
    },
};
</script>
  
<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.historic {
    padding: 30px;
    width: 600px;
    overflow: auto;
    max-height: 400px;
    @media (max-width: $small) {
        width: inherit;
    }

    .line {
        border-radius: 3px;
        padding: 8px;

        &:nth-child(even) {
            background: $white-9;
        }
    }

    .title {
        font-weight: bold;
        height: 30px;
        color: $gray-6;
        font-size: 14px;
    }
}
</style>